module.exports = __webpack_public_path__ + "static/media/tommy3.58bd2945.svg";